// src/modules/competition/components/CakeGiverCard/index.js
import React from 'react';
import { Card, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { DEFAULT_TEAM_ICON } from '../TeamManager';

const CakeGiverCard = ({ competitor, team }) => {
    const empty = (
        <Card className="mb-3 h-100">
            <Card.Header as="h5">Current Cake Giver</Card.Header>
            <Card.Body className="text-center">
                <Card.Title>No cake Giver 🍰</Card.Title>
            </Card.Body>
        </Card>
    );

    if (team) {
        return (
            <Card className="mb-3 h-100">
                <Card.Header as="h5">Current Cake Giver</Card.Header>
                <Card.Body className="text-center">
                    <div style={{ fontSize: '4rem', lineHeight: 1, marginBottom: '1rem' }}>
                        {team.icon || DEFAULT_TEAM_ICON}
                    </div>
                    <Card.Title>{team.name} 🍰</Card.Title>
                    <Card.Text>
                        Team Points: {team.totalPoints?.toFixed(2)}
                    </Card.Text>
                </Card.Body>
            </Card>
        );
    }

    if (!competitor) return empty;

    return (
        <Card className="mb-3 h-100">
            <Card.Header as="h5">Current Cake Giver</Card.Header>
            <Card.Body className="text-center">
                <Image
                    src={competitor.profilePicture || '/default-avatar.png'}
                    roundedCircle
                    style={{ width: '100px', height: '100px', objectFit: 'cover', marginBottom: '1rem' }}
                    alt={`${competitor.firstName}'s profile`}
                />
                <Card.Title>{competitor.firstName} 🍰</Card.Title>
                <Card.Text>
                    Points Current Period: {competitor.totalPoints?.toFixed(2)}
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

CakeGiverCard.propTypes = {
    competitor: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number.isRequired,
    }),
    team: PropTypes.shape({
        name: PropTypes.string.isRequired,
        icon: PropTypes.string,
        totalPoints: PropTypes.number,
    }),
};

export default CakeGiverCard;
